import { handleActions } from 'redux-actions';

import { coreActions } from 'app-components/flux/core-actions';
import { jobStatusActions } from 'app-components/flux/job-status';
import {
  appSetOnlineStatus,
  appSetServiceWorkerIsRegistered,
  appSetServiceWorkerIsRegistering,
  appSetServiceWorkerUpdateIsAvailable,
  setAppProps,
  setAwaitingToAutoRefresh,
} from 'data/app/actions';
import { importDataFailure, importDataSuccess } from 'data/import/importActions';

import { appRefreshAll } from './actions';
import { mkAppStore } from './types';

const reducer = handleActions(
  {
    [appSetOnlineStatus]: (state, { payload: value }) => state.merge({ isOffline: !value }),

    [appSetServiceWorkerIsRegistered]: (state, { payload: value }) =>
      state.merge({ serviceWorkerIsRegistered: value, serviceWorkerIsRegistering: false }),
    [appSetServiceWorkerIsRegistering]: (state, { payload: value }) =>
      state.merge({
        serviceWorkerIsRegistering: value,
        serviceWorkerIsRegistered: value ? false : state.serviceWorkerIsRegistered,
      }),

    [appSetServiceWorkerUpdateIsAvailable]: (state, { payload: value }) =>
      state.merge({ serviceWorkerUpdateIsAvailable: value }),

    [coreActions.sanitize]: (state) => state.merge({ isSanitized: true }),
    [coreActions.persistDataLoadComplete]: (state) =>
      state.merge({
        awaitingToAutoRefresh: false,
        fetchInProgress: false,
        isOffline: false,
        serviceWorkerIsRegistered: false,
        serviceWorkerIsRegistering: false,
        serviceWorkerUpdateIsAvailable: undefined,
      }),

    [setAwaitingToAutoRefresh]: (state, { payload: value }) => state.set('awaitingToAutoRefresh', value),

    [jobStatusActions.createJobStatus]: (state) => state.merge({ fetchInProgress: true }),
    [jobStatusActions.deleteJobStatus]: (state) => state.merge({ fetchInProgress: false }),

    [setAppProps]: (state, { payload }) => state.mergeDeep(payload),

    [coreActions.setUpdateAllState]: (state, { payload }) => state.mergeDeep(payload),

    [importDataSuccess]: (state, { payload }) =>
      state.mergeDeep({
        csvImportCompleteByClientId: state.csvImportCompleteByClientId.set(payload.clientId, payload),
      }),

    [importDataFailure]: (state, { payload }) =>
      state.mergeDeep({ csvImportErrorByClientId: state.csvImportErrorByClientId.set(payload.clientId, payload) }),

    [appRefreshAll]: (state, action) => {
      if (action.meta?.props?.crashReducer) {
        throw new Error('Simulate Reducer Crash');
      }
      return state;
    },
  },
  mkAppStore(),
);

export const APP_REDUCER_KEY = 'appStore';
export default reducer;
